module.exports = __webpack_public_path__ + "static/media/radio-unchecked.a1d03a76.svg";